import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { number, object, func, string } from "prop-types";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";

import Button from "../../atoms/button";
import PopupModal from "../../atoms/popup-modal";
import PaymentFailure from "../../molecules/payment-failure";
import SubscribePlans from "./subscription-plans";
import SupportDescriptionView from "./descriptions-view";
import MobileNumberUpdateView from "../../molecules/mobile-number-update-view";
import PayButtonView from "../../molecules/pay-button-view";
import LoginPay from "../../rows/login-pay";
import { readCookie, eraseCookie } from "../../../../isomorphic/components/helper/cookies";

import main from "./icons/main.svg";

import { setLoading } from "../../helper/actions";
import { isMobileNoPresent } from "../../utils/utils";

import { getAllPlans } from "../../helper/access-type";

import "./i-day.m.css";

const PlanSelectionPageView = ({ recommendedId, member, setLoading, currentPath }) => {
  const [allPlans, setAllPlans] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [oneTimePlans, setOneTimePlans] = useState([]);

  useEffect(() => {
    if (global.AccessType) {
      getAllPlans().then((plans) => filterPlans(plans));
    }
  }, []);

  useEffect(() => {
    if (readCookie("status") === "failure") {
      eraseCookie("status");
      setShowPopup(true);
    }
  }, []);

  const handlePlanSelect = (index) => {
    setSelectedIndex(index);
  };

  const filterPlans = (plans) => {
    const allPlans = plans.filter((i) => i.subscription_group_id === 186);
    const sortedPlans = allPlans.filter((i) => i.price_cents).sort((planA, planB) => planA.id - planB.id);
    setAllPlans(allPlans);
    setOneTimePlans(sortedPlans);
  };

  const getPaySupportView = () => {
    // If mobile number not available when user is logged in then request user to update it
    if (!isMobileNoPresent(member)) {
      return <MobileNumberUpdateView member={member} setLoading={setLoading} />;
    }

    const planObj = oneTimePlans[selectedIndex];
    return (
      <PayButtonView
        member={member}
        setLoading={setLoading}
        plans={allPlans}
        plan={planObj}
        currentPath={currentPath}
      />
    );
  };

  const faqClick = () => window.open("/membership/faq", "_blank");

  return (
    <div styleName="wrapper">
      <div styleName="first-block" style={{ backgroundImage: `url(${assetify(main)})` }}>
        <span styleName="support-quint-description">This Independence Day,</span>
        <span styleName="support-quint-title">Support Press Freedom</span>
        <SubscribePlans
          selectedIndex={selectedIndex}
          setSelectedIndex={handlePlanSelect}
          plans={oneTimePlans}
          recommendedId={recommendedId}
        />
        <span styleName="message1">
          This is a seamless payment plan. You can cancel your membership anytime from the profile page.
        </span>
        <span styleName="message1 message2">We deeply value the trust you have invested in us.</span>
      </div>

      {member ? getPaySupportView() : <LoginPay />}

      <div styleName="help">
        Unable to login or make payments?&nbsp;
        <div>
          &nbsp;Write to us at
          <a href="mailto:payments@thequint.com" styleName="help-mail">
            payments@thequint.com
          </a>
        </div>
      </div>

      <div styleName="faq-wrapper">
        <span styleName="faq-title">Frequently Asked Questions</span>
        <Button content="Click Here" buttonType="type2" onClick={faqClick} />
      </div>

      <SupportDescriptionView />

      <iframe
        styleName="video-wrapper"
        src="https://www.youtube.com/embed/GmWidole6MI"
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen=""
      ></iframe>

      {showPopup ? (
        <PopupModal closePopup={() => setShowPopup(false)}>
          <PaymentFailure />
        </PopupModal>
      ) : null}
    </div>
  );
};

PlanSelectionPageView.propTypes = {
  recommendedId: number,
  member: object,
  setLoading: func,
  navigateToPage: func,
  publisherName: string,
  currentPath: string,
};

const mapStateToProps = (state) => {
  const config = get(state, ["qt", "config", "publisher-attributes"]);

  return {
    recommendedId: config.accesstype["i-day-recommended"],
    publisherName: config.name,
    member: state.member,
    currentPath: get(state, ["qt", "currentPath"], ""),
  };
};

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
});

const NewMembership = connect(mapStateToProps, mapDispatchToProps)(PlanSelectionPageView);

export { NewMembership };
